// extracted by mini-css-extract-plugin
export default {"container":"BreadcrumbsBar_container__++OmQ"};